export default {
    data(){
        return {
            hoveredElement: null
        }
    },
    methods: {
        onThHover: function(columnField, status, containerId = null){
            if (status)
            {
                this.hoveredElement = columnField;
            }
            else
            {
                this.hoveredElement = null;
            }

            let selector = '.colgroup_' + columnField;
            if( containerId ) {
                selector = selector + '_' + containerId;
            }

            document.querySelectorAll(selector).forEach(el => {
                if (status)
                {
                    el.classList.add('hovered');
                }
                else
                {
                    el.classList.remove('hovered');
                }
            });
        },
        isColumnHovered: function(columnField){
            if (this.hoveredElement == columnField)
            {
                return true;
            }

            return false;
        },
        removeHovering(columnIndex){
            this.onThHover(columnIndex, false);
        }
    }
}


// WEBPACK FOOTER //
// ./src/components/reports/mixins/hoverTableMixin.js